import { render, staticRenderFns } from "./modalCupon.vue?vue&type=template&id=2ad490ac&scoped=true&"
import script from "./modalCupon.vue?vue&type=script&lang=js&"
export * from "./modalCupon.vue?vue&type=script&lang=js&"
import style0 from "./modalCupon.vue?vue&type=style&index=0&id=2ad490ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad490ac",
  null
  
)

export default component.exports